import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgIconHeartFilled = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M18.0112 4.97922C16.3399 4.38734 14.1532 4.90204 12.6024 6.98795C12.4617 7.17726 12.24 7.28932 12.0042 7.29047C11.7683 7.29162 11.5456 7.18172 11.403 6.9938C9.81529 4.90109 7.62501 4.38977 5.96486 4.97995C4.33296 5.56008 3.00292 7.28381 3.28893 10.1439C3.49652 12.2199 4.61894 14.1696 6.13745 15.8672C7.65129 17.5596 9.50917 18.945 11.0743 19.8852C11.6461 20.2286 12.355 20.2286 12.9267 19.8852C14.4918 18.945 16.3497 17.5596 17.8636 15.8672C19.3821 14.1696 20.5045 12.2199 20.7121 10.144C20.9976 7.28847 19.655 5.56135 18.0112 4.97922Z",
		fill: "#FF3859"
	})
});
export { SvgIconHeartFilled as ReactComponent };
